export class SenderIdDTO {

    constructor(
        public originationId: string,
        public countryCode: string
    ) { }
}
